import { EndpointMessageInterface } from "../../../interfaces/EndpointMessage.interface";

export function bigIntReplacer(_key: string, value: unknown): unknown {
  if (typeof value === "bigint") return value.toString();
  return value;
}

export function buildTypeLabel(record: EndpointMessageInterface): string {
  if (record.typeName) {
    return record.isFlatBuffer ? `${record.typeName} (FlatBuffer)` : record.typeName;
  }
  return record.isFlatBuffer ? "FlatBuffer (unknown type)" : "JSON";
}

export function formatForClipboard(record: EndpointMessageInterface): string {
  const payload: Record<string, unknown> = {
    timestamp: new Date(record.timestamp).toISOString(),
    method: record.method,
    url: record.url,
    status: record.status,
    duration: `${record.duration}ms`,
    type: buildTypeLabel(record),
  };

  if (record.error) payload.error = record.error;
  if (record.schemaHash) payload.schemaHash = record.schemaHash;
  if (record.requestBody !== undefined && record.requestBody !== null) {
    payload.requestBody = record.requestBody;
  }
  if (record.responseBody !== undefined && record.responseBody !== null) {
    payload.responseBody = record.responseBody;
  }

  return JSON.stringify(payload, bigIntReplacer, 2);
}
